<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>AGREGAR DOCUMENTOS</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="pt-2 px-6">
        <!-- DATOS SHOW -->
        <div class="vx-row">
          <small>
            <div class="vx-col w-full">
              <p><span class="font-semibold">Cliente: </span>{{this.clientInfo.names_client | capitalize}} {{this.clientInfo.surnames_client | capitalize}} ({{ this.clientInfo.email_user }})</p>
              <p v-if="addedServicesForAClientInmigrationActive"><span class="font-semibold">Servicio: </span>{{ this.addedServicesForAClientInmigrationActive.name_service }}</p>
              <p v-if="addedServicesForAClientInmigrationActive"><span class="font-semibold">Tipo de Visa: </span>{{ this.addedServicesForAClientInmigrationActive.name_visa_type }}</p>
            </div>
          </small>
        </div>

        <!-- SELECCION DE FAMILIAR AL QUE APLICA EL DOCUMENTO -->
        <div class="vx-row">
          <div class="vx-col w-full mt-2">
            <label class="vs-input--label">Seleccione a qué familiar aplica los documentos a requerir <small>(opcional)</small></label>
            <v-select :closeOnSelect="true" v-model="id_family" :options="clientFamily" label="names_family" :reduce=" clientFamily => clientFamily.id_family">
              <template #option="{ names_family, surnames_family, name_family_type }">
                <small>
                  <vs-list class="vs-list--title p-0 m-0"> {{ names_family }} {{ surnames_family }}</vs-list>
                  <vs-list class="vs-list--subtitle p-0 m-0"> {{ name_family_type }}</vs-list>
                </small>
              </template>
              <template #selected-option="{ names_family, surnames_family, name_family_type }">
                <small>
                  <span><b>{{ names_family }} {{ surnames_family }}</b> ({{ name_family_type }})</span>
                </small>
              </template>
            </v-select>
          </div>
        </div>

        <vs-divider class="pt-8 mb-2" color="primary">Documento personalizado</vs-divider>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input label="Nombre del tipo de Documento personalizado" v-model="custom_name_document" placeholder=" " class="mt-2 w-full" name="custom_name_document" />
          </div>
        </div>
        <div class="vx-row flex justify-end">
          <vs-button ref="loadableButton" id="button-with-loading" class="vs-con-loading__container mr-8 mt-4" color="success" size="medium" @click.stop="submitVisaRequirementCustom()">+ Agregar Documento Personalizado</vs-button>
        </div>

        <div class="vx-row" v-if="this.arrayVisaRequirement.length > 0">
          <vs-divider class="pt-8 mb-2" color="primary"></vs-divider>
          <div class="vx-col w-full mt-4">
            <label class="vs-input--label">Documentos cargados:</label>
            <ul>
              <li v-for="(item, index) in this.arrayVisaRequirement" :key="index">
              <p class="text-sm"> <feather-icon icon="CheckIcon" svgClasses="w-4 h-4" /> {{ item.name_visa_document_type }} <small v-if="item.id_family"> - {{ getFamilyName(item.id_family) }}</small></p>
              </li>
            </ul>
          </div>
        </div>

        <vs-divider class="pt-8 mb-2" color="primary"></vs-divider>

        <!-- LIST OF DOCUMENTS -->
        <div class="vx-row">
          <div class="vx-col w-full vs-con-loading__container" id="div-with-loading">
            <vs-list>
              <vs-list-header title="Documentos"></vs-list-header>
              <vs-input label="" v-model="search" placeholder="Busca por nombre..." class="mt-2 w-full" />
              <!--
              <vs-list-item :subtitle="document.name_visa_document_type" v-for="(document, index) in visaDocumentTypes" :key="index">
                <vs-button ref="loadableButton" id="button-with-loading" class="vs-con-loading__container" color="success" size="small" @click.stop="submitVisaRequirement(document)">+ Agregar</vs-button>
              </vs-list-item>
              -->
            </vs-list>
          </div>
        </div>


      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.stop="resumeSubmit()">Aceptar</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { arrival_date_added_service } = JSON.parse(JSON.stringify(this.data))
        this.arrival_date_added_service = arrival_date_added_service
        this.clearFields()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data () {
    return {
      visaDocumentTypesFiltered: null,
      search: '',
      arrayVisaRequirement: [],
      id_family: null,
      document: null,
      name_visa_document_type: null,
      arrival_date_added_service: null,
      arrival_date: null,
      id_service: null,
      id_visa_type: null,
      custom_name_document: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    clientInfo () {
      return this.$store.state.clientInfo
    },
    roles () {
      if (this.$store.state.clientInfo.roles) return this.$store.state.clientInfo.roles.map(item => item.name_role).toString()
    },
    addedServicesForAClientInmigrationActive () {
      return this.$store.state.addedServicesForAClientInmigrationActive[0]
    },
    // eslint-disable-next-line vue/return-in-computed-property
    visaDocumentTypes () {
      return this.$store.state.visaDocumentTypes.filter(item => {
        return item.name_visa_document_type.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    clientFamily () {
      return this.$store.state.clientFamily
    },
    isFormValid () {
      return !this.errors.any() && this.arrival_date
    }
  },
  methods: {
    getFamilyName (id_family) {
      if (!id_family) return
      return `${this.clientFamily.filter(item => item.id_family === id_family)[0].names_family} ${this.clientFamily.filter(item => item.id_family === id_family)[0].surnames_family} (${this.clientFamily.filter(item => item.id_family === id_family)[0].name_family_type})`
    },
    submitVisaRequirement (document) {
      this.$vs.loading()
      if (document) {
        this.$store.dispatch('addItemVisaRequirementForAClient', {
          visa_document_type_id : document.id_visa_document_type,
          added_service_id: this.addedServicesForAClientInmigrationActive.id_added_service,
          family_id: this.id_family ? this.id_family : undefined
        }).then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Documento agregado',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check'
          })
        }).then(() => {
          const newDoc = {
            name_visa_document_type: document.name_visa_document_type,
            id_family: this.id_family
          }
          this.arrayVisaRequirement.push(newDoc)
          this.search = ''
        }).catch(err => {
          console.error(err)
          this.$vs.loading.close()
          if (typeof err.response.data.errors === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${err.response.data.errors}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(err.response.data.errors)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
      }
    },
    submitVisaRequirementCustom () {
      this.$vs.loading()
      if (document) {
        const visaRequirementPostObj = {
          name_visa_document_type: this.custom_name_document,
          added_service_id: this.addedServicesForAClientInmigrationActive.id_added_service,
          family_id: this.id_family
        }
        if (!this.id_family) delete visaRequirementPostObj.family_id
        this.$store.dispatch('addItemVisaRequirementForAClient', visaRequirementPostObj).then(() => {
          this.$vs.loading.close()
          this.$vs.notify({ title: 'Documento agregado', color: 'success', iconPack: 'feather', icon:'icon-check' })
        }).then(() => {
          const newDoc = {
            name_visa_document_type: this.custom_name_document,
            id_family: this.id_family
          }
          this.arrayVisaRequirement.push(newDoc)
          this.search = ''
        }).catch(err => {
          console.error(err)
          this.$vs.loading.close()
          if (typeof err.response.data.errors === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${err.response.data.errors}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(err.response.data.errors)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
      }

    },
    initValues () {
      if (this.data.id_client) return
      this.arrival_date = null
    },
    clearFields () {
      this.id_family = null
      this.arrayVisaRequirement = []
    },
    resumeSubmit () {
      if (this.arrayVisaRequirement.length > 0) {
        this.$emit('closeSidebarSuccess')
        this.clearFields()
      }
      this.$emit('closeSidebar')
      this.clearFields()

    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
}
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 750px;
    max-width: 100vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.demo-alignment {
  margin-top:-15px;
}
</style>
